import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
// Charts

/* import { ordersChart } from "@/components/Charts/Chart";
import Chart from "chart.js"; */
import PageVisitsTable from "./Dashboard/PageVisitsTable";
import SocialTrafficTable from "./Dashboard/SocialTrafficTable";
/* let chart; */

import { getDashboardStatistics } from "../apis/services/steemActivity";
export default {
  components: {
    PageVisitsTable: PageVisitsTable,
    SocialTrafficTable: SocialTrafficTable
  },
  data: function data() {
    return {
      salesChartID: "salesChart",
      ordersChartID: "ordersChart",
      dashboardStatistics: {
        totalPeolpeNum: 0,
        thirtyDayPeolpeNum: 0,
        totalBonus: 0,
        totalSbiBonus: 0
      },
      bigLineChart: {
        allData: [[0, 20, 10, 30, 15, 40, 20, 60, 60], [0, 20, 5, 25, 10, 30, 15, 40, 40]],
        activeIndex: 0
      }
    };
  },
  methods: {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDashboardStatistics();

            case 2:
              _this.dashboardStatistics = _context.sent.data;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};